export function formatPropertyAddress(property, fallback = 'Address N/A') {
  if (!property) return fallback;

  const parts = [
    property.address,
    property.city,
    property.state,
    property.zipCode,
  ]
    .map((part) => (part ?? '').toString().trim())
    .filter(Boolean);

  if (parts.length > 0) {
    return parts.join(', ');
  }

  return property.location || property.formattedAddress || fallback;
}

export function formatPropertyShortAddress(property, fallback = 'Address N/A') {
  if (!property) return fallback;

  const parts = [property.address, property.city]
    .map((part) => (part ?? '').toString().trim())
    .filter(Boolean);

  return parts.length > 0 ? parts.join(', ') : formatPropertyAddress(property, fallback);
}

export function propertyImageAlt(property) {
  return `${formatPropertyAddress(property, 'Property')} photo`;
}
